import styled from "styled-components";

export const Skeleton = styled.div`
  height: ${({ height }) => height || "auto"};
`;
